import { render, staticRenderFns } from "./CreateGame.vue?vue&type=template&id=207a9a05&"
import script from "./CreateGame.vue?vue&type=script&lang=js&"
export * from "./CreateGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports